import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify"

const AuthLayout = ({ children }: any) => {
  return <>
  <div className="main_screen " style={{backgroundImage:'url(/assets/img/bg.jpg)'}}>
  <div className="bg_div flex w-full items-center justify-center h-[100vh] bg-[#000000a6]">
    <div className='main_class grid items-center grid-cols-12 w-[550px] p-[2rem] bg-[#f1f1f129] rounded-[8px] '>

      <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
        <div className="relative flex flex-col items-center justify-center overflow-auto ">

          <div className="shadow-box w-full max-[499px]:px-[15px] max-[639px]:px-[25px] sm:px-[3rem] py-6 mx-auto overflow-hidden bg-white rounded-lg min-h-[442px]">
            {/* <Link to='/'> */}
            <Link to=''>
              <img src="/assets/img/logo.png" className="w-[120px] mb-6 mx-auto" alt="logo" />
            </Link>
            {children}
          </div>

        </div>
      </div>
      {/* <div className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
      <div className="relative w-full">
      <img src="/assets/img/login_img.png" alt="bg-logon" width="auto" height="auto" className="h-[420px] rounded-r-lg

" />
      </div>
        </div> */}

      {/* <div className="col-span-2 hidden md:flex md:col-span-6 lg:col-span-6 xl:col-span-6">
        <div className="relative w-full">
          <img src="https://img.freepik.com/free-vector/sign-concept-illustration_114360-125.jpg" alt="bg-logon" width="auto" height="auto" className="" />
          <div className="bg-black/30 flex flex-col justify-between h-full   py-6 px-3 xs:px-4 md:px-4  xl:px-12 xl:py-16 relative z-20">
          </div>
        </div>
      </div> */}
    </div>
    </div>
    </div>
    <ToastContainer position="top-right" />
  </>
}

export default AuthLayout